export const IS_LOADING = "IS_LOADING";
export const IS_SAVING = "IS_SAVING";
export const LEAVE_ADDED = "LEAVE_ADDED";
export const LEAVE_UPDATED = "LEAVE_UPDATED";
export const GET_LEAVES = "GET_LEAVES";